const MAX_DIMENSION = 1200;
const JPEG_QUALITY = 0.82;

const readFileAsImage = (file) => new Promise((resolve, reject) => {
  const img = new Image();
  const reader = new FileReader();
  reader.onload = () => {
    img.onload = () => resolve(img);
    img.onerror = () => reject(new Error("Could not read image file."));
    img.src = reader.result;
  };
  reader.onerror = () => reject(new Error("Could not read file."));
  reader.readAsDataURL(file);
});

/**
 * Downscales + re-encodes an uploaded image client-side so the catalog never
 * accumulates multi-MB phone photos. Returns both a Blob (for upload) and a
 * data URL (for instant preview / localStorage demo mode).
 */
export async function processProductImage(file) {
  if (!file.type.startsWith("image/")) {
    throw new Error("Please choose an image file.");
  }

  const img = await readFileAsImage(file);
  let { width, height } = img;

  if (width > MAX_DIMENSION || height > MAX_DIMENSION) {
    if (width >= height) {
      height = Math.round((height / width) * MAX_DIMENSION);
      width = MAX_DIMENSION;
    } else {
      width = Math.round((width / height) * MAX_DIMENSION);
      height = MAX_DIMENSION;
    }
  }

  const canvas = document.createElement("canvas");
  canvas.width = width;
  canvas.height = height;
  const ctx = canvas.getContext("2d");
  ctx.fillStyle = "#FFFFFF";
  ctx.fillRect(0, 0, width, height);
  ctx.drawImage(img, 0, 0, width, height);

  const blob = await new Promise((resolve) => {
    canvas.toBlob((result) => resolve(result), "image/jpeg", JPEG_QUALITY);
  });
  const dataUrl = canvas.toDataURL("image/jpeg", JPEG_QUALITY);

  return { blob, dataUrl, width, height };
}
